
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site-password",
      function () {
        return require("private-next-pages/site-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site-password"])
      });
    }
  